import React, { useState } from 'react';
import { IconButton, CircularProgress, Snackbar, Alert } from '@mui/material';
// import GavelIcon from '@mui/icons-material/Gavel';
import nakdanIcon from '../../Assets/images/nakdan-icon.png';

import axios from 'axios';
import urls from '../../Mobx/Urls';

const NakdanButton = ({ text, onNikudComplete }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success', // 'success' | 'error'
    });

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const handleNakdanClick = async () => {
        if (!text.trim()) {
            setSnackbar({
                open: true,
                message: 'אין טקסט לנקד',
                severity: 'error',
            });
            return;
        }

        try {
            setIsLoading(true);
            const response = await axios.post(
                urls.ai.nakdan,
                { text },
                { withCredentials: true }
            );

            const nikudText = response.data.nikud;

            if (nikudText) {
                onNikudComplete(nikudText);
            } else {
                throw new Error("לא התקבל טקסט מנוקד");
            }

        } catch (error) {
            console.error('שגיאה בניקוד:', error);
            setSnackbar({
                open: true,
                message: `שגיאה בניקוד: ${error?.response?.data || error.message}`,
                severity: 'error',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <IconButton onClick={handleNakdanClick} disabled={isLoading}>
                {/* {isLoading ? <CircularProgress size={24} /> : <GavelIcon titleAccess="נקד" />} */}
                {isLoading ? (
                    <CircularProgress size={15} />
                ) : (
                    <img src={nakdanIcon} alt="נקד" style={{ width: 15, height: 18 }} />
                )}
            </IconButton>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={30000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default NakdanButton;
